export default function InfoModalIcon() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M22 12C22 6.47686 17.5231 2 12 2C6.47686 2 2 6.47686 2 12C2 13.6982 2.42455 15.3374 3.2224 16.7951C3.83556 17.9145 4.65887 18.908 5.64474 19.7216C7.42283 21.1855 9.64993 22 12 22C17.5231 22 22 17.5231 22 12ZM3 12C3 7.02914 7.02914 3 12 3C16.9709 3 21 7.02914 21 12C21 16.9709 16.9709 21 12 21C9.88406 21 7.88107 20.2675 6.2808 18.95C5.39304 18.2173 4.65145 17.3224 4.09952 16.3148C3.38183 15.0035 3 13.5293 3 12ZM11.5 10.4741V16.5259C11.5 16.7877 11.7239 17 12 17C12.2761 17 12.5 16.7877 12.5 16.5259V10.4741C12.5 10.2123 12.2761 10 12 10C11.7239 10 11.5 10.2123 11.5 10.4741ZM12 7.2207C12.367 7.2207 12.665 7.5187 12.665 7.8857C12.665 8.2527 12.367 8.5507 12 8.5507C11.633 8.5507 11.335 8.2527 11.335 7.8857C11.335 7.5187 11.633 7.2207 12 7.2207Z" fill="#323C32" />
    </svg>
  );
}
